<template>
  <div v-if="markers.length" class="bottomRouge">
    <gmap-map
      class="infoBorder gmap"
      :center="{
        lat: markers[0].latitude,
        lng: markers[0].longitude,
      }"
      :zoom="12"
      :options="{
        mapTypeControlOptions: mapType,
      }"
      ref="mapCartoGeneral"
      @tilesloaded="initCarto">
      <gmap-marker
        v-for="(m, index) in markers"
        :key="index"
        :clickable="true"
        :position="{
          lat: m.latitude,
          lng: m.longitude,
        }"
        @click="afficher(m)"
        :icon="m.icon">
      </gmap-marker>
      <gmap-marker
        v-if="markerClient.lat"
        :position="{
          lat: markerClient.lat,
          lng: markerClient.lng,
        }"
        :icon="markerClient.icon">
      </gmap-marker>
    </gmap-map>
    <transition
      name="custom-classes-transition"
      enter-active-class="animated slideInRight"
      leave-active-class="animated slideOutRight"
      :duration="300"
      v-on:after-enter="bg = true"
      v-on:after-leave="bg = false"
      mode="out-in">
      <detail-opp-panneau-lc
        :bg="bg"
        :detailFaceLc="detailFace"
        v-if="show && detailFace.type === 'panneauxLc'"/>
      <detail-opp-panneau-numerique
        :bg="bg"
        :detailFaceNumerique="detailFace"
        v-if="show && detailFace.type === 'panneauxNumeriques'"/>
      <detail-opp-reseau-lc
        :bg="bg"
        :detailReseauxLcComplet="detailFace"
        v-if="show && detailFace.type === 'reseauxLc'"/>
      <detail-opp-reseau-numerique
        :bg="bg"
        :detailReseauxNumeriqueComplet="detailFace"
        v-if="show && detailFace.type === 'reseauxNumeriques'"/>
      <detail-opp-reseau-personnalise
        :bg="bg"
        :detailFace="detailFace"
        v-if="show && detailFace.type === 'reseauxPersonnalise'"/>
      <detail-opp-reseau-tempo
        :bg="bg"
        :detailFace="detailFace"
        v-if="show && detailFace.type === 'reseauxTempo'"/>
    </transition>
  </div>
</template>

<script>
import detailOppPanneauLc from '@/components/opportuniteClient/propositions/panneauxLc/detailOpportunites';
import detailOppPanneauNumerique from '@/components/opportuniteClient/propositions/panneauxNumeriques/detailOpportunites';
import detailOppReseauLc from '@/components/opportuniteClient/propositions/reseauxLc/detailReseauxLcComplet';
import detailOppReseauNumerique from '@/components/opportuniteClient/propositions/reseauxNumeriques/detailReseauxNumeriqueComplet';
import detailOppReseauPersonnalise from '@/components/opportuniteClient/propositions/reseauxPersonnalise/detailReseauxPersonnaliseComplet';
import detailOppReseauTempo from '@/components/opportuniteClient/propositions/reseauxTempo/detailTempo';
import {
  MAP_TYPE_CONTROL_OPTIONS,
  STYLE_MAPS_POI_HIDDEN, MAP_TYPE_NAME,
} from '@/configurations/configurationCarto';
import filterLatLng from '@/services/general/gestionLatLng';

export default {
  name: 'cartoGeneral',
  props: ['markers', 'markerClient'],
  components: {
    detailOppPanneauLc,
    detailOppPanneauNumerique,
    detailOppReseauLc,
    detailOppReseauNumerique,
    detailOppReseauPersonnalise,
    detailOppReseauTempo,
  },
  data() {
    return {
      moyLat: 0,
      moyLng: 0,
      centreCarte: {},
      detailFace: {},
      show: false,
      bg: false,
      isLoadOnce: false,
      mapType: MAP_TYPE_CONTROL_OPTIONS,
    };
  },
  methods: {
    afficher(face) {
      this.detailFace = face;
      this.show = true;
    },
    async levelZoom() {
      const bounds = new google.maps.LatLngBounds();
      filterLatLng(this.markers);
      this.markers.forEach(m => {
        if (Math.trunc(m.latitude) !== 0 || Math.trunc(m.longitude) !== 0) {
          bounds.extend({ lat: m.latitude, lng: m.longitude });
        }
      });
      if (this.markerClient !== undefined && this.markerClient.lat !== undefined &&
      this.markerClient.lat !== null) {
        bounds.extend({ lat: this.markerClient.lat, lng: this.markerClient.lng });
      }
      this.$refs.mapCartoGeneral.fitBounds(bounds);
    },
    async initPoi() {
      const map = await this.$refs.mapCartoGeneral.$mapPromise;
      const styleMap = new google.maps.StyledMapType(STYLE_MAPS_POI_HIDDEN, {
        name: MAP_TYPE_NAME,
      });
      map.mapTypes.set('styled_map', styleMap);
    },
    async initCarto() {
      if (!this.isLoadOnce) {
        await this.initPoi();
        if (this.markers.length) {
          await this.levelZoom();
        }
        this.isLoadOnce = true;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/opportuniteClient/propositions/cartoGeneral/carte.vue